import React from "react";
import MyTitle from "../../myTitle";
import Btn from "../../btn";
import styleObj from "../style.module.scss";
import styleObj2021 from "./style.module.scss";
import title from "../../../assets/imgs/intro-2021.png";
export default function Intro2021(props) {
  let { actAddress } = props;

  return (
    <div className={styleObj["intro-wrap"]}>
      <MyTitle {...props} title={title} />
      <div className={styleObj["content"]}>
        <div className={styleObj["left"]}>
          <div className={styleObj["text"]}>
            <div className={styleObj2021["title"]}>创围 围在一起才是好年</div>
            <div className={styleObj2021["desc"]}>创维电视元春品鉴</div>
            <div className={styleObj2021["tips"]}>
              创维电视将你我围在一起过新年
            </div>
          </div>
          <img
            className={`${styleObj["entrance"]} ${styleObj2021["entrance"]}`}
            src={require("../../../assets/imgs/entrance2021.png")}
            alt=""
          />
          <img
            className={styleObj["pendant-dot"]}
            src={require("../../../assets/imgs/pendant-dot-2021.png")}
            alt=""
          />
        </div>
        <div className={styleObj["right"]}>
          <Btn
            className={styleObj["btn"]}
            href={actAddress}
            text="立即参加"
            {...props}
          />
        </div>
      </div>
    </div>
  );
}
